import { Box } from '@chakra-ui/react';
import { Text, Colors } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

/**
 * Section heading used to group filters inside a sidebar. A quiet small label
 * above a thin divider. Shared across every filter sidebar so sections render
 * identically (Company Search, Filing Search, Project Insights).
 */

const sectionLabelContainerStyle = {
  gap: 'padding_4',
  paddingTop: 'padding_12',
  paddingBottom: 'padding_2',
  paddingX: 'padding_8',
  width: '100%',
};

const firstSectionLabelContainerStyle = {
  ...sectionLabelContainerStyle,
  paddingTop: 'padding_16',
};

const dividerStyle = {
  height: '1px',
  width: '100%',
  backgroundColor: Colors.ArmyGreen300,
};

type SidebarSectionLabelProps = {
  label: string;
  /** Tightens the top padding for the first section in a sidebar. */
  isFirst?: boolean;
};

export const SidebarSectionLabel = ({
  label,
  isFirst = false,
}: SidebarSectionLabelProps) => {
  return (
    <FlexColumn
      sx={isFirst ? firstSectionLabelContainerStyle : sectionLabelContainerStyle}
    >
      <Text.SmallLabel color={Colors.TextQuiet}>{label}</Text.SmallLabel>
      <Box sx={dividerStyle} />
    </FlexColumn>
  );
};

export default SidebarSectionLabel;
